import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { DeadlineDateStyles } from '../styles/deadlineDate';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFormattedDeadlineDate, getTCPlusFormattedDeadlineDate } from '../../common/utils/dateFormatter';
import { routeMappings, SessionStore } from '../../constants';
import { TaskListStyleConfig } from '../interfaces';
import { useBasicDetails } from '../../store';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getExperienceInitCookie } from '../../common/utils/experienceInitCookie';
import { getCookie } from '../../common/utils/cookies';

interface DeadlineDateProps {
  styles: TaskListStyleConfig;
}

const DeadlineDate = (props: DeadlineDateProps): JSX.Element => {
  const { t } = useTranslation();
  const location = useLocation();
  const { userSessionActive } = useBasicDetails();
  const classes = DeadlineDateStyles(props.styles);
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';

  const date = sessionStorage.getItem(SessionStore.candidateDeadlineDate);
  let deadlineDate: string | undefined = getFormattedDeadlineDate(parseInt(date ? date.replace('/Date(', '') : '', 10));
  const onTaskListPage = location.pathname.includes(routeMappings['TASKLIST']);
  if (tcPlusFlow) {
    const expCookie = getExperienceInitCookie();
    const candidateDeadlineDate = expCookie && expCookie.candidateDeadlineDate;
    deadlineDate = candidateDeadlineDate && getTCPlusFormattedDeadlineDate(candidateDeadlineDate);
  }

  const showDeadlineDateMsg =
    userSessionActive && deadlineDate && deadlineDate !== 'Invalid date' && deadlineDate.length > 0 && onTaskListPage;

  return (
    <>
      {showDeadlineDateMsg && (
        <Grid item xs={12}>
          <Box mt={2} display="flex">
            <FontAwesomeIcon icon={faCalendarDay} className={classes.calenderIcon} />
            <Typography variant="body1" className={classes.deadlineDate}>
              {t('completeByMsg', { deadlineDate })}
            </Typography>
          </Box>
        </Grid>
      )}
    </>
  );
};

export default DeadlineDate;
